import { atom } from 'jotai';

type AuthStatus = 'unAuth' | 'auth' | 'logout';

interface SessionState {
  flag: AuthStatus;
  rawSession: any | null;
}

export const sessionAtom = atom<SessionState>({
  flag: 'unAuth',
  rawSession: null,
});

export const cacheSessionAtom = atom((get) => {
  const sessionState = get(sessionAtom);
  const { flag, rawSession } = sessionState;

  if (flag === 'logout' || flag === 'unAuth') {
    return {
      data: null,
      status: 'unauthenticated' as const,
    };
  }
  return {
    data: rawSession,
    status: 'authenticated' as const,
  };
});

/**
 * 设置原始会话数据和认证状态。
 * @param session 会话数据
 * @param status 可选，认证状态 (unAuth, auth, logout)
 */
export const setRawSessionAtom = atom(
  null,
  (get, set, session: any | null, status?: AuthStatus) => {
    if (status) {
      const prevSessionState = get(sessionAtom);
      const prevRawSession = prevSessionState.rawSession;
      const prevFlag = prevSessionState.flag;

      if (
        status === 'auth' &&
        prevFlag === 'auth' &&
        prevRawSession?.user?.id &&
        session?.user?.id &&
        prevRawSession.user.id === session.user.id
      ) {
        return;
      }
      set(sessionAtom, (prev) => ({
        ...prev,
        rawSession: session,
        flag: status,
      }));
    } else {
      set(sessionAtom, (prev) => ({
        ...prev,
        rawSession: session,
      }));
    }
  },
);

/**
 * 设置认证状态。
 * @param flag 认证状态 (unAuth, auth, logout)
 */
export const setFlagAtom = atom(null, (_, set, flag: AuthStatus) => {
  set(sessionAtom, (prev) => ({ ...prev, flag }));
});
